import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=20015191&scoped=true&"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManagementDashboard.vue?vue&type=style&index=0&id=20015191&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20015191",
  null
  
)

export default component.exports